  <div [class]="model.ratingRootCss" #contentElement>
      <fieldset role="radiogroup">
          <legend role="presentation" class="sv-hidden"></legend>
          <span *ngIf="model.hasMinLabel" [class]="model.cssClasses.minText" [model]="model.locMinRateDescription" sv-ng-string>
          </span>
          <ng-template *ngFor="let item of model.renderedRateItems; index as index; trackBy: trackByFn" [component]="{ name: model.itemComponent, data: {model: model, item: item, index: index }}"></ng-template>
          <span *ngIf="model.hasMaxLabel" [class]="model.cssClasses.maxText" [model]="model.locMaxRateDescription" sv-ng-string></span>
      </fieldset>
  </div>
